function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M5 6.37776C5 5.06999 6.04996 4 7.33324 4H23.6659C24.9492 4 25.9991 5.06999 25.9991 6.37776V26.1924C25.9991 27.5002 24.9492 28.5702 23.6659 28.5702H11.6108L5 21.8332H11.6108V26.1924H23.6659V6.37776H7.33324V19.8517H5V6.37776Z"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M11.222 11.5296C12.3108 11.5296 13.1663 12.4014 13.1663 13.511C13.1663 14.6207 12.3108 15.4925 11.222 15.4925H10.4442V17.0777H9.27762V11.5296H11.222ZM10.4442 14.3036H11.222C11.6497 14.3036 11.9997 13.947 11.9997 13.511C11.9997 13.0751 11.6497 12.7185 11.222 12.7185H10.4442V14.3036Z"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M21.7215 11.5296V12.7185H19.7772V13.9073H21.3326V15.0962H19.7772V17.0777H18.6105V11.5296H21.7215Z"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M15.5773 11.5296H13.9441V17.0777H15.5773C16.8217 17.0777 17.8328 16.0473 17.8328 14.7792V13.8281C17.8328 12.5599 16.8217 11.5296 15.5773 11.5296ZM16.6662 14.7792C16.6662 15.3736 16.1995 15.8888 15.5773 15.8888H15.1107V12.7185H15.5773C16.1606 12.7185 16.6662 13.194 16.6662 13.8281V14.7792Z"
});

var SvgDocument = function SvgDocument(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgDocument, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Document.25ca635b.svg";
export { ForwardRef as ReactComponent };